import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { PercentageCatalogItem } from '@core/models';
import { environment } from '@env/environment';
import { catchError, Observable, tap, throwError } from 'rxjs';

export interface PercentageRequestBody {
  amount: number;
  unitMeasure: string;
  thresholdCapital?: number | null;
}

@Injectable({ providedIn: 'root' })
export class PercentageCatalogApiService {
  private readonly baseUrl = `${environment.baseUrl}/percentages`;
  private http = inject(HttpClient);

  private _items = signal<PercentageCatalogItem[]>([]);

  getItems() {
    return this._items.asReadonly();
  }

  loadCatalog(): Observable<PercentageCatalogItem[]> {
    return this.http.get<PercentageCatalogItem[]>(`${this.baseUrl}/catalog`).pipe(
      tap((items) => this._items.set(items)),
      catchError((err) => throwError(() => err)),
    );
  }

  createPercentage(dto: PercentageRequestBody): Observable<PercentageCatalogItem> {
    return this.http.post<PercentageCatalogItem>(`${this.baseUrl}`, dto).pipe(
      catchError((err) => throwError(() => err)),
    );
  }

  updatePercentage(id: number, dto: PercentageRequestBody): Observable<PercentageCatalogItem> {
    return this.http.put<PercentageCatalogItem>(`${this.baseUrl}/${id}`, dto).pipe(
      catchError((err) => throwError(() => err)),
    );
  }

  deletePercentage(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.baseUrl}/${id}`).pipe(
      tap(() => this._items.set(this._items().filter((p) => p.id !== id))),
      catchError((err) => throwError(() => err)),
    );
  }
}
